import { Sparkles } from "lucide-react";
import { useCart } from "../contexts/CartContext";

/**
 * Subtle tiered discount strip shown across key pages.
 * On mobile: auto-scrolling marquee ticker. On desktop: static centered.
 * variant: "strip" (full-width), "badge" (inline)
 */
export default function TierDiscountStrip({ variant = "strip" }) {
  const { discountInfo, cartCount } = useCart();

  const tier2 = discountInfo?.tier_2 || 10;
  const tier3 = discountInfo?.tier_3 || 15;
  const tier4 = discountInfo?.tier_4plus || 20;
  const currentDiscount = discountInfo?.discount_percent || 0;
  const nextTier = discountInfo?.next_tier;

  let msg;
  if (cartCount > 0 && nextTier) {
    msg = currentDiscount > 0
      ? `You're saving ${currentDiscount}% — add ${nextTier.items_needed} more for ${nextTier.next_discount}% off!`
      : `Add ${nextTier.items_needed} more item${nextTier.items_needed > 1 ? "s" : ""} to unlock ${nextTier.next_discount}% off your entire cart!`;
  } else {
    msg = `Rent 2+ items and save: ${tier2}% off 2 items · ${tier3}% off 3 items · ${tier4}% off 4+`;
  }

  if (variant === "badge") {
    return (
      <div className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-[#9A7B4F]/8 text-[10px] text-[#9A7B4F] tracking-wide" data-testid="tier-badge">
        <Sparkles className="w-3 h-3" strokeWidth={1.5} />
        <span>{msg}</span>
      </div>
    );
  }

  return (
    <div className="w-full bg-[#9A7B4F]/[0.06] border-b border-[#9A7B4F]/10 py-1.5 sm:py-2 overflow-hidden" data-testid="tier-strip">
      {/* Desktop: static centered */}
      <div className="hidden sm:flex items-center justify-center gap-2 px-4 text-[11px] text-[#9A7B4F]">
        <Sparkles className="w-3.5 h-3.5 flex-shrink-0" strokeWidth={1.5} />
        <span>{msg}</span>
      </div>
      {/* Mobile: auto-scrolling marquee */}
      <div className="sm:hidden relative">
        <div className="tier-marquee flex items-center gap-2 text-[10px] text-[#9A7B4F] whitespace-nowrap">
          <span className="inline-flex items-center gap-1.5">
            <Sparkles className="w-3 h-3 flex-shrink-0" strokeWidth={1.5} />
            {msg}
          </span>
          <span className="mx-8">·</span>
          <span className="inline-flex items-center gap-1.5">
            <Sparkles className="w-3 h-3 flex-shrink-0" strokeWidth={1.5} />
            {msg}
          </span>
          <span className="mx-8">·</span>
        </div>
        <style>{`
          .tier-marquee {
            animation: tierScroll 18s linear infinite;
          }
          @keyframes tierScroll {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
        `}</style>
      </div>
    </div>
  );
}
